import { render, staticRenderFns } from "./CandidateListDialog.vue?vue&type=template&id=20a54e66"
import script from "./CandidateListDialog.vue?vue&type=script&lang=js"
export * from "./CandidateListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports